import React from 'react';

export const Lending = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M14.6 24.2L29 24.2M29 24.2L24.2 19.4M29 24.2L24.2 29'
                stroke='currentColor'
                strokeWidth='3.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M3.79999 24.2C3.79999 22.2118 5.41176 20.6 7.39999 20.6C9.38821 20.6 11 22.2118 11 24.2C11 26.1882 9.38821 27.8 7.39999 27.8C5.41176 27.8 3.79999 26.1882 3.79999 24.2Z'
                fill='currentColor'
            />
            <path
                d='M19.4 9.79999L5 9.8M5 9.8L9.8 14.6M5 9.8L9.8 5'
                stroke='currentColor'
                strokeWidth='3.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M30.2 9.80002C30.2 11.7882 28.5882 13.4 26.6 13.4C24.6118 13.4 23 11.7882 23 9.80002C23 7.8118 24.6118 6.20002 26.6 6.20002C28.5882 6.20002 30.2 7.8118 30.2 9.80002Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default Lending;
